import {
  NPVR_NOT_RECORDABLE_EVENT_STATUS,
  NPVR_RECORDABLE_EVENT_STATUS,
  NPRV_SCHEDULED_STATUS,
  NPVR_RECORDING_STATUS,
  NPVR_RECORDED_STATUS,
  NPRV_SCHEDULED_STRING,
  NPVR_RECORDING_STRING,
  NPVR_RECORDED_STRING,
  NPRV_SCHEDULED_STATUS_CANCEL,
  NPVR_RECORDING_STATUS_CANCEL,
  NPVR_RECORDED_STATUS_CANCEL
} from './Constans';
import Asset from '../../requests/apa/Asset';
import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import AAF from '../AAF';
import Utils from './../../utils/Utils';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import { Dates } from '../../packages/dates';
import Translator from '../../requests/apa/Translator';

const parseStringStatusToInt = function(stringStatus) {
  switch (stringStatus) {
    case NPRV_SCHEDULED_STRING:
      return NPRV_SCHEDULED_STATUS;
    case NPVR_RECORDING_STRING:
      return NPVR_RECORDING_STATUS;
    case NPVR_RECORDED_STRING:
      return NPVR_RECORDED_STATUS;
    default:
      return NPVR_RECORDABLE_EVENT_STATUS;
  }
};


const parseIntStatusToString = function(stringStatus) {
  switch (stringStatus) {
    case NPRV_SCHEDULED_STATUS:
      return NPRV_SCHEDULED_STRING;
    case NPVR_RECORDING_STATUS:
      return NPVR_RECORDING_STRING;
    case NPVR_RECORDED_STATUS :
      return NPVR_RECORDED_STRING;
    default:
      return NPRV_SCHEDULED_STRING;
  }
};

/**
 * get the asset url depends on the recording status
 * @param {number} status
 */
const getRecordingAsset = function(status) {
  let imageSrc;
  let label;
  let assetFromMetadata = null;
  
  switch (status) {
    case NPVR_NOT_RECORDABLE_EVENT_STATUS:
      imageSrc = '';
      label = '';
      break;
    case NPVR_RECORDABLE_EVENT_STATUS:
      assetFromMetadata = Asset.get('npvr_epg_recording_icon_canRecord', false);
      imageSrc = Asset.get('recording_miniEpg_canRecord_icon', '/images/mini-epg/ic_grabar.png')
      label = Metadata.get('recording_npvr_canRecord_label ', 'Grabar');
      break;
    case NPRV_SCHEDULED_STATUS:
      assetFromMetadata = Asset.get('npvr_epg_recording_icon_toRecord', false);
      imageSrc = Asset.get('recording_miniEpg_toRecord_icon', '/images/mini-epg/ic_grabando.png')
      label = Metadata.get('recording_npvr_toRecord_label ', 'Por grabar');
      break;
    case NPVR_RECORDING_STATUS:
      assetFromMetadata = Asset.get('npvr_epg_recording_icon_recordingBlink', false);
      imageSrc = Asset.get('recording_miniEpg_recordingBlink_icon', '/images/mini-epg/ic_grabando.png')
      label = Metadata.get('recording_npvr_recorded_label ', 'Grabando');
      break;
    case NPVR_RECORDED_STATUS:
      assetFromMetadata = Asset.get('npvr_epg_recording_icon_recorded', false);
      imageSrc = Asset.get('recording_miniEpg_recorded_icon', '/images/mini-epg/ic_grabado.png')
      label = Metadata.get('recording_npvr_recordingBlink_label ', 'Grabado');
      break;
    // CASOS PARA STATUS CANCELADOS
    case NPRV_SCHEDULED_STATUS_CANCEL:
      assetFromMetadata = Asset.get('npvr_epg_recording_icon_recorded', false);
      imageSrc = Asset.get('recording_miniEpg_recorded_icon', '/images/mini-epg/ic_grabar.png')
      label = Metadata.get('recording_npvr_recordingBlink_label ', 'Cancelaste la grabación');
      break
    case NPVR_RECORDING_STATUS_CANCEL:
      assetFromMetadata = Asset.get('npvr_epg_recording_icon_recorded', false);
      imageSrc = Asset.get('recording_miniEpg_recorded_icon', '/images/mini-epg/ic_grabar.png')
      label = Metadata.get('recording_npvr_recordingBlink_label ', 'Dejaste de grabar');
      break
    case NPVR_RECORDED_STATUS_CANCEL:
      assetFromMetadata = Asset.get('npvr_epg_recording_icon_recorded', false);
      imageSrc = Asset.get('recording_miniEpg_recorded_icon', '/images/mini-epg/ic_grabar.png')
      label = Metadata.get('recording_npvr_recordingBlink_label ', 'Eliminaste la grabación');
      break
    default:
      imageSrc = '';
      label = '';
  }
  return {
    imageSrc,
    label
  };
};
/**
 * get boolean to know if recording icon in epg is enable
 */
const recordingIconEnable = function() {
  try {
    const region = DeviceStorage.getItem('region');
    const defaultKey = '{"default":{"enable":true}}';
    let metadataKey = Metadata.get('npvr_epg_recording_icon', defaultKey);
    metadataKey = JSON.parse(metadataKey);
    return metadataKey[region] || metadataKey['default'];
  } catch (e) {
    return { enable: false };
  }
};

const getTimeToGetRecordings = function() {
  try {
    const region = DeviceStorage.getItem('region');
    const defaultKey = '{"default":{"minutes":5}}';
    let metadataKey = Metadata.get('time_to_get_recordings', defaultKey);
    metadataKey = JSON.parse(metadataKey);
    return metadataKey[region] || metadataKey['default'];
  } catch (e) {
    return { minutes: 5 };
  }
};

const setFormatTimesEvent = function(eventInfo) {
  if (!isNaN(eventInfo.date_begin)) {
    eventInfo.date_begin = EpgPersistence.needsOffset()
      ? new Dates()
        .unix(eventInfo.date_begin)
        .utcOffset(EpgPersistence.needsOffset(), false)
        .format('YYYY/MM/DD HH:mm:ss')
      : new Dates().unix(eventInfo.date_begin).format('YYYY/MM/DD HH:mm:ss');
  }
  if (!isNaN(eventInfo.date_end)) {
    eventInfo.date_end = EpgPersistence.needsOffset()
      ? new Dates()
        .unix(eventInfo.date_end)
        .utcOffset(EpgPersistence.needsOffset(), false)
        .format('YYYY/MM/DD HH:mm:ss')
      : new Dates().unix(eventInfo.date_end).format('YYYY/MM/DD HH:mm:ss');
  }

  return eventInfo;
};

const canTimeShiftFromEvent = function(event) {
  event = setFormatTimesEvent(event);

  const timeshiftAllowed =
    ChannelSingleton.getTimeshift(event.channel_group_id || event.group_id) * 60 +
    AAF.Timeshift.calcTSExcedecTime();

  const now = Utils.now(true);
  const beginMoment = EpgPersistence.needsOffset()
    ? new Dates(event.date_begin).utcOffset(EpgPersistence.needsOffset(), true)
    : new Dates(event.date_begin);
  const endMoment = EpgPersistence.needsOffset()
    ? new Dates(event.date_end).utcOffset(EpgPersistence.needsOffset(), true)
    : new Dates(event.date_end);
  const diffStart = now.diff(beginMoment, 'seconds');
  const diffEnd = now.diff(endMoment, 'seconds');

  const startMatch = diffStart <= timeshiftAllowed;
  const endMatch =
    diffEnd <=
    (startMatch ? timeshiftAllowed : timeshiftAllowed - AAF.Timeshift.calcTSExcedecTime());
  const dateBegin = startMatch
    ? event.date_begin
    : now.subtract(timeshiftAllowed, 'seconds').format('YYYY/MM/DD HH:mm:ss');

  return diffStart > 0 && (startMatch || endMatch) ? dateBegin : false;
};

const eventIsInTimeshiftWindow = function(event, isPastEvent) {
  if (!isPastEvent) return false;
  const timeshiftAllowedExeded =
    ChannelSingleton.getTimeshift(event.channel_group_id || event.group_id) * 60 +
    AAF.Timeshift.calcTSExcedecTime();
  const now = Utils.now(true).unix();
  const beginUnix = EpgPersistence.needsOffset()
    ? new Dates(event.date_begin)
      .utcOffset(EpgPersistence.needsOffset(), true)
      .unix()
    : new Dates(event.date_begin).unix();
  const endUnix = EpgPersistence.needsOffset()
    ? new Dates(event.date_end)
      .utcOffset(EpgPersistence.needsOffset(), true)
      .unix()
    : new Dates(event.date_end).unix();
  const endTimeshif =
    beginUnix < now - timeshiftAllowedExeded
      ? ChannelSingleton.getTimeshift(event.channel_group_id || event.group_id) * 60
      : timeshiftAllowedExeded;
  const isIn = endUnix <= now && endUnix > now - endTimeshif ? true : false;

  return isIn;
};

const getButtonRecord = function(key) {

  const configuration = Utils.getApaMetadataKey('timeshift_npvr_configuration', null, key);

  if (configuration){
    return configuration.enable;
  }

  return false;

};

const eventIsRecordable = function(eventInfo) {
  if (!eventInfo) return false;
  /*
  "recording_id":"0","group_id":"781189","ext_catchup":"1","ext_year":null,"type":"0","nextEventId":"465622178",
  "channel_id":"1300603","date_end":1585071000,"id":"465622177",
  "ext_eventimage_name":"http://clarovideocdn6.clarovideo.net/EPG/603/656ea8769b0825fcd2ce142dfdadd368_v-168x96.jpg?size=168x96",
  "duration":"00:30:00","parental_rating":null,"ext_recordable":"1",
  "description":"Vive toda la acción del deporte a nivel mundial en todas sus disciplinas.","name":"Sports Max","date_beg
  */
  eventInfo = setFormatTimesEvent(eventInfo);
  const groupId = eventInfo.channel_group_id || eventInfo.group_id;

  const canPlayChannel = ChannelSingleton.canPlayChannel(groupId);
  const userHash = DeviceStorage.getItem('user_hash') || '';
  const recordable = eventInfo.ext_recordable === '1';
  // const canWeTimeShift = canTimeShiftFromEvent(eventInfo);
  // const dateBegin = canWeTimeShift ? canWeTimeShift : eventInfo.date_begin;
  const dateEnd = eventInfo.date_end;
  const isPastEvent = Utils.isDateBetween(dateEnd, Utils.now(true).unix());
  const isFutureEvent = Utils.isCurrentEventFuture({ event: eventInfo });
  let isCurrentEvent = false;
  if(eventInfo.date_begin && eventInfo.date_end){
    isCurrentEvent = Utils.isDateBetween(eventInfo.date_begin, eventInfo.date_end);
  }


  const isPastEventInTimeshiftWindow = eventIsInTimeshiftWindow(eventInfo, isPastEvent);
  const recordingsEnabled = getButtonRecord('npvr_button_record');
  const hasNpvrStorage = ChannelSingleton.getNpvrStorage(groupId) != 0 ? true : false;

  const isRecordableEvent =
    canPlayChannel &&
    userHash !== 'undefined' &&
    recordable &&
    (isPastEventInTimeshiftWindow || isFutureEvent || isCurrentEvent) &&
    recordingsEnabled &&
    hasNpvrStorage;

  return isRecordableEvent;
};


const viewButtonRecording = function(eventInfo) {
  if (!eventInfo) return false;
 
  const groupId = eventInfo.event.channel_group_id || eventInfo.event.group_id;
  const recordable = eventInfo.event.ext_recordable === '1';
  
  const recordingsEnabled = getButtonRecord('npvr_button_record');
  const hasNpvrStorage = ChannelSingleton.getNpvrStorage(groupId) !== 0 ? true : false;

  const isRecordableEvent = recordable && recordingsEnabled && hasNpvrStorage;

  return isRecordableEvent;
};



const NpvrUtil = {
  getRecordingAsset: getRecordingAsset,
  recordingIconEnable: recordingIconEnable,
  parseStringStatusToInt: parseStringStatusToInt,
  getTimeToGetRecordings: getTimeToGetRecordings,
  eventIsRecordable: eventIsRecordable,
  getButtonRecord: getButtonRecord,
  eventIsInTimeshiftWindow: eventIsInTimeshiftWindow,
  canTimeShiftFromEvent: canTimeShiftFromEvent,
  parseIntStatusToString: parseIntStatusToString,
  viewButtonRecording : viewButtonRecording
};

export { NpvrUtil };



// WEBPACK FOOTER //
// ./src/AAF/Npvr/NpvrUtil.js